export default __webpack_public_path__ + "static/media/C3.8facde75.svg";